export const sideObjOne = {
    productPDF: require('../../docs/Attochron_ALTIS-7_Specifications 041524.pdf')
}